export const minAdvanceMinutes = 60;
export const minAdvanceMinutesLong = 75;
export const maxAdvanceHours = 24;
export const maxAdvanceHoursLoggedIn = 72;
export const minDuration = 60;
export const maxDuration = 1440; // 24h

export const genders = [
  { id: 1, name: "Female" },
  { id: 2, name: "Transsexual" },
];

export const services = [
  { id: 1, name: "A-Level", description: "Receives anal" },
  { id: 2, name: "BBBJ", description: "BBBJ" },
  { id: 3, name: "CIM", description: "Cum in mouth" },
  { id: 4, name: "Rimming", description: "Gives rimming" },
  { id: 5, name: "Couples", description: "Has sex with couples" },
  { id: 7, name: "DFK", description: "Deep French kissing" },
  { id: 8, name: "COF", description: "Cum on face" },
  { id: 9, name: "COB", description: "Cum on body" },
  { id: 10, name: "DATY", description: "Dine at the Y" },
  { id: 13, name: "Massage", description: "Massage" },
  { id: 14, name: "Guide", description: "Travel guide" },
  { id: 15, name: "Lesbian", description: "Lesbian" },
  { id: 16, name: "DT", description: "Deep throat" },
];

export const countries = [
  {
    id: 620,
    name: "Portugal",
    callingCode: 351,
    currencyCode: "EUR",
    currencySymbol: "€",
  },
  {
    id: 360,
    name: "Indonesia",
    callingCode: 62,
    currencyCode: "USD",
    currencySymbol: "$",
  },
  {
    id: 764,
    name: "Thailand",
    callingCode: 66,
    currencyCode: "THB",
    currencySymbol: "฿",
  },
  {
    id: 608,
    name: "Philippines",
    callingCode: 63,
    currencyCode: "PHP",
    currencySymbol: "₱",
  },
  {
    id: 826,
    name: "United Kingdom",
    callingCode: 44,
    currencyCode: "GBP",
    currencySymbol: "£",
  },
  { id: 840, name: "United States of America", callingCode: 1 },
  // { id: 356, name: "India", callingCode: 91 },
  {
    id: 702,
    name: "Singapore",
    callingCode: 65,
    currencyCode: "SGD",
    currencySymbol: "S$",
  },
  {
    id: 344,
    name: "Hong Kong",
    callingCode: 852,
    currencyCode: "HKD",
    currencySymbol: "HK$",
  },
  { id: 784, name: "United Arab Emirates", callingCode: 971 },
  {
    id: 276,
    name: "Germany",
    callingCode: 49,
    currencyCode: "EUR",
    currencySymbol: "€",
  },
  { id: 250, name: "France", callingCode: 33 },
  { id: 380, name: "Italy", callingCode: 39 },
  {
    id: 528,
    name: "Netherlands",
    callingCode: 31,
    currencyCode: "EUR",
    currencySymbol: "€",
  },
  { id: 756, name: "Switzerland", callingCode: 41 },
  { id: 643, name: "Russia", callingCode: 7 },
  {
    id: 392,
    name: "Japan",
    callingCode: 81,
    currencyCode: "JPY",
    currencySymbol: "¥",
  },
  { id: 410, name: "Korea", callingCode: 82 },
  { id: 554, name: "New Zealand", callingCode: 64 },
  {
    id: 458,
    name: "Malaysia",
    callingCode: 60,
    currencyCode: "MYR",
    currencySymbol: "RM",
  },
  {
    id: 156,
    name: "China",
    callingCode: 86,
    currencyCode: "HKD",
    currencySymbol: "HK$",
  },
  {
    id: 724,
    name: "Spain",
    callingCode: 34,
    currencyCode: "EUR",
    currencySymbol: "€",
  },
  {
    id: 116,
    name: "Cambodia",
    callingCode: 855,
    currencyCode: "USD",
    currencySymbol: "$",
  },
  {
    id: 704,
    name: "Vietnam",
    callingCode: 84,
    currencyCode: "USD",
    currencySymbol: "$",
    // currencyCode: "VND",
    // currencySymbol: "₫",
  },
  {
    id: 36,
    name: "Australia",
    callingCode: 61,
    currencyCode: "AUD",
    currencySymbol: "$",
  },
  {
    id: 616,
    name: "Poland",
    callingCode: 48,
    currencyCode: "PLN",
    currencySymbol: "zł",
  },
];

export const ages = [
  { id: "", name: "Any age" },
  { id: "18-23", name: "18-23" },
  { id: "24-29", name: "24-29" },
  { id: "30-35", name: "30-35" },
  { id: "35-", name: "35+" },
];

export const heights = [
  { id: "", name: "Any height" },
  { id: "short", name: "Short (< 156 cm)" },
  { id: "average", name: "Average (156-165 cm)" },
  { id: "tall", name: "Tall (> 165 cm)" },
];

export const endowments = [
  { id: "", name: "Any size" },
  { id: "small", name: "Small" },
  { id: "medium", name: "Medium" },
  { id: "large", name: "Large" },
  { id: "xlarge", name: "X-Large" },
  { id: "post-op", name: "Post op" },
];

export const orientations = [
  { id: "", name: "Any orientation" },
  { id: "top", name: "Top" },
  { id: "bottom", name: "Bottom" },
  { id: "versatile", name: "Versatile" },
];

export const cups = [
  { id: "", name: "Any size" },
  { id: "A", name: "A" },
  { id: "B", name: "B" },
  { id: "C", name: "C" },
  { id: "D", name: "D" },
  { id: "D+", name: "D+" },
  { id: "E", name: "E" },
  { id: "F", name: "F" },
  { id: "G", name: "G" },
];

export const bodyTypes = [
  { id: "", name: "Any body type" },
  { id: "slim", name: "Slim" },
  { id: "avg", name: "Average" },
  { id: "athletic", name: "Athletic" },
  { id: "curvy", name: "Curvy" },
  // { id: "bbw", name: "BBW" },
];

export const modelLanguages = {
  en: "English",
  zh: "Chinese",
  jp: "Japanese",
  ko: "Korean",
  de: "German",
  nl: "Dutch",
  fr: "French",
  es: "Spanish",
};

export const modelLanguageLevels = {
  basic: "Basic",
  avg: "Average",
  fluent: "Fluent",
};

export const steps = [
  "region",
  "city",
  "gender",
  "outcall",
  "time",
  "duration",
];
